module.exports = __webpack_public_path__ + "static/media/tkl-small-white.2b987075.png";